import {Component, Input, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

import {ExampleSJ, Word} from "../../models/word.model";
import {CordovaService} from '../../services/cordova/cordova.service';
import {TfSpiceService} from '../../services/tf-service/tf-spice.service';
import {VoiceService} from '../../services/voice/voice.service';
import {OptionService} from '../../services/option/option.service';
import {PitchService} from '../../services/pitch/pitch.service';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';
import {
  SAMPLE_RATE
} from '../../defines/pitch.const';
import {RecorderService} from "../../services/recorder/recorder.service";
import {WordPitchPopupComponent} from '../word-pitch-popup/word-pitch-popup.component';
// import {samplePitches} from '../../defines/dummy.const';

const offlineCtx = new OfflineAudioContext(1, SAMPLE_RATE, SAMPLE_RATE);

@Component({
  selector: 'app-word-example-popup',
  templateUrl: './word-example-popup.component.html',
  animations: [
    trigger('PitchInOut', [
      transition(':enter', [
        style({transform: 'translateY(100%)'}),
        animate('150ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({transform: 'translateY(50%)'}))
      ])
    ]),
  ],
})
export class WordExamplePopupComponent extends WordPitchPopupComponent implements OnInit {
  @Input() declare word: Word;
  @Input() exampleSJ: ExampleSJ | null = null;

  constructor(
    protected cordovaSvc: CordovaService,
    protected tfSpiceSvc: TfSpiceService,
    protected voiceSvc: VoiceService,
    protected optionSvc: OptionService,
    protected recorderSvc: RecorderService,
    public pitchSvc: PitchService,
    public lm: LayoutMgrService,
  ) {
    super(
      cordovaSvc,
      tfSpiceSvc,
      voiceSvc,
      optionSvc,
      recorderSvc,
      pitchSvc,
      lm,
    );
  }

  ngOnInit(): void {
    // console.warn('app-word-example-popup ngOnInit()', this.word, this.exampleSJ);

    if (this.cordova && this.word && 'exampleVoice' in this.word && this.exampleSJ?.voiceExIdx !== null) {
      const exVoiceIdx = this.exampleSJ!.voiceExIdx;
      const urlVoice = this.word?.exampleVoice[exVoiceIdx];

      this.init(urlVoice, exVoiceIdx);
    }
    else if (this.exampleSJ?.seungjo !== null) {
      this.init();
    }
  }


}
